<!-- toast-end/toast-top keeps these clear of the fixed left sidebar -->
<div class="toast toast-top toast-end z-[60]">
  @for (notification of toasts; track notification.id) {
    <div class="alert bg-base-100 border border-base-300 shadow-lg w-80 flex items-start gap-2">
      <span class="mt-1 h-2 w-2 rounded-full bg-primary flex-shrink-0" aria-hidden="true"></span>

      <button class="flex-1 text-left" (click)="open(notification)">
        <span class="block text-sm font-medium leading-snug whitespace-normal">
          {{ notification.message }}
        </span>
        <span class="block text-xs text-base-content/50 mt-0.5">View</span>
      </button>

      <button
        class="btn btn-ghost btn-xs text-base-content/40 hover:text-error"
        aria-label="Dismiss"
        (click)="dismiss(notification)"
      >
        ✕
      </button>
    </div>
  }
</div>
